import React from 'react'
import InvoiceChangeLotsDialog from '../../dialogs/changes/InvoiceChangeLotsDialog';
import InvoiceChangeInvoiceModifiersDialog from '../../dialogs/changes/InvoiceChangeInvoiceModifiersDialog';
import InvoiceChangeContactCreditsDialog from '../../dialogs/changes/InvoiceChangeContactCreditsDialog';
import ViewPaymentsDialog from '../../dialogs/payments/InvoiceViewPaymentsDialog';
import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '@agtech/web/components/Menus/AgTechVerticalPopUpMenu';
import { InvoiceInfo } from '@sales/data/invoicing/InvoicingData';
import InvoiceInfoDialog from '../../dialogs/InvoiceInfoDialog';

export type InvoiceActionMenuProps = {
    invoice: InvoiceInfo
}

const InvoiceActionMenu = (props: InvoiceActionMenuProps) => {
    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header='Info'>
                <InvoiceInfoDialog.Button
                    invoiceId={props.invoice.id}
                    text='View Invoice'
                    showNextSteps={true}
                />
            </AgTechVerticalPopUpMenuSection>
            <AgTechVerticalPopUpMenuSection header="Amendments">
                <InvoiceChangeLotsDialog.Button
                    invoiceId={props.invoice.id}
                    contactId={props.invoice.contactId}
                />
                <InvoiceChangeInvoiceModifiersDialog.Button
                    invoiceId={props.invoice.id}
                    contactId={props.invoice.contactId}
                />
                <InvoiceChangeContactCreditsDialog.Button
                    invoiceId={props.invoice.id}
                    contactId={props.invoice.contactId}
                />
            </AgTechVerticalPopUpMenuSection>
            <AgTechVerticalPopUpMenuSection header="Payments">
                <ViewPaymentsDialog.Button
                    invoiceId={props.invoice.id}
                />
            </AgTechVerticalPopUpMenuSection>
        </AgTechVerticalPopUpMenu>
    )
}

export default InvoiceActionMenu